import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
  SET_CERTIFICATES: "SET_CERTIFICATES",
  GENERAL_CERTIFICATES_REQUEST: "GENERAL_CERTIFICATES_REQUEST",
  GENERAL_CERTIFICATES_SUCCESS: "GENERAL_CERTIFICATES_SUCCESS",
  GENERAL_CERTIFICATES_ERROR: "GENERAL_CERTIFICATES_ERROR",
  DELETE_CERTIFICATES_SUCCESS: "DELETE_CERTIFICATES_SUCCESS"
};

export const setCertificates = (profile) => {
  const certificationsWithPersonId = profile.certifications.map(publication => Object.assign(publication, {person_id: profile.id}));
  const noData = certificationsWithPersonId.length === 0;
  return {
    type: actions.SET_CERTIFICATES,
    personId: profile.id,
    body: certificationsWithPersonId,
    noData
  }
};

export const certificatesApiCall = (personId, payload, type, callbackToHOC) => {
  const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : "DELETE" );
  const endpoint = type === 'CREATE' ? '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);

  const _payload = {...payload};
  if (requestType !== 'DELETE') {
    const endDate = payload.i_still_study_here ? undefined : ( payload.end_year.value && payload.end_month.value ? `${ payload.end_year.value }-0${ payload.end_month.value }` : "");
    const noEndDateDBFix = ( type === 'CREATE' ? undefined : '' );

    _payload.start_date = `${ payload.start_year.value }-0${ payload.start_month.value }`;
    _payload.end_date = ( endDate === "undefined-0undefined" || !endDate ) ? noEndDateDBFix : endDate;
  }

  return (dispatch) => {
    dispatch({
      type: actions.GENERAL_CERTIFICATES_REQUEST,
      isCertificatesFetching: true,
      isCertificatesError: false
    });

    requestHelpers
      .authenticatedPostRequest(`/profiles/${ personId }/certification${endpoint}`, _payload, requestType)
      .then((response) => {
        payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
        callbackToHOC();
        return dispatch({
          type: requestType === 'DELETE' ? actions.DELETE_CERTIFICATES_SUCCESS : actions.GENERAL_CERTIFICATES_SUCCESS,
          personId,
          body: requestType === 'DELETE' ? payload : _payload,
          isCertificatesFetching: false,
          isCertificatesError: false
        })
      }).catch((error) => {
        callbackToHOC(error);
        return dispatch({
          type: actions.GENERAL_CERTIFICATES_ERROR,
          isCertificatesFetching: false,
          isCertificatesError: true,
          error: error.status
        })
      })

    dispatch(updateTodoList(personId, 8));
  }
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/certificates.js